import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { MetaOptions } from '@x/common/meta';
import { ChannelContextService } from '@x/ecommerce-shop/app/channel/services/channel-context.service';
import { MenuRemoveActive } from '@x/ecommerce-shop/app/core/menu/state/menu.actions';
import { ShopMetaService } from '@x/ecommerce-shop/app/core/shop-meta/shop-meta.service';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChannelState } from '../../state';

@Component({
  selector: 'x-channel-home',
  templateUrl: './channel-home.component.html',
  styleUrls: ['./channel-home.component.scss'],
  host: { class: 'x-channel-home' },
})
export class ChannelHomeComponent implements OnInit {
  meta$: Observable<MetaOptions> = combineLatest([
    this.store.select(ChannelState.activeChannel),
    this.store.select(ChannelState.activeChannelContent),
  ]).pipe(
    map(([channel, content]) => {
      return this.shopMetaService.getMetaByPriority({
        entityMeta: channel?.meta,
        contentMeta: content?.metaData,
      });
    }),
  );

  content$ = this.channelService.channelContent$;

  constructor(
    private store: Store,
    private shopMetaService: ShopMetaService,
    private channelService: ChannelContextService,
  ) {}

  ngOnInit(): void {
    this.store.dispatch([new MenuRemoveActive()]);
  }
}
